import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-pagamentos-nao-integrados',
  templateUrl: './pagamento-nao-integrados.component.html',
  styleUrl: './pagamento-nao-integrados.component.css'
})
export class ContratosPagamentosNaoIntegradosComponent {

}
